import { render, staticRenderFns } from "./PendingMedia.vue?vue&type=template&id=32dd1be0&scoped=true"
import script from "./PendingMedia.vue?vue&type=script&lang=js"
export * from "./PendingMedia.vue?vue&type=script&lang=js"
import style0 from "./PendingMedia.vue?vue&type=style&index=0&id=32dd1be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd1be0",
  null
  
)

export default component.exports